import React, { useCallback, useMemo } from "react";
import {
  Row,
  Col,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Alert
} from "reactstrap";
import LinkProperty from "../../molecules/link-property";
import NodeWrapperProperty from "../../molecules/node-wrapper-property";
import { NODE_NAMES, START } from "../../../utils/nodeTypes";
import { dbType } from "../../../utils/mrTypes";
import { t } from "../../../utils/utils";
import T from "../../atoms/translate";

export default function PropertyBar({ toggle, open, onPropertyChange, args }) {
  const isNewNode = () => {
    if (args && args.dependencies) {
      if (args.type !== "link" && args.data.type !== dbType) {
        const { context } = args.dependencies;
        if (context) {
          return false;
        } else if (args.data.type !== START) {
          return true;
        }
      }
    }
    return false;
  };
  const onChangeNodeProperty = useCallback(
    node => {
      onPropertyChange(state => {
        state.nodes[node.id] = node;
        return state;
      });
    },
    [onPropertyChange]
  );
  const onChangeLinkProperty = useCallback(
    link => {
      onPropertyChange(state => {
        state.links[link.id] = link;
        return state;
      });
    },
    [onPropertyChange]
  );
  const onChangeQuantifier = useCallback(
    quantifier => {
      onPropertyChange({ quantifier: quantifier });
    },
    [onPropertyChange]
  );
  const changeComponent = useMemo(
    () =>
      args.type === "link" ? (
        <LinkProperty link={args.data} linkChange={onChangeLinkProperty} />
      ) : (
        <NodeWrapperProperty
          node={args.data}
          dependencies={{
            changeQuantifier: onChangeQuantifier,
            ...args.dependencies
          }}
          nodeChange={onChangeNodeProperty}
        />
      ),
    [args, onChangeNodeProperty, onChangeLinkProperty, onChangeQuantifier]
  );
  const modalTitle = () => {
    if (args && args.type === "link") {
      return t("nodoLinkTitulo");
    } else if (args && args.type === "node" && args.data && args.data.type) {
      return t(NODE_NAMES[args.data.type].title);
    }
    return null;
  };

  const modalDescription = () => {
    if (args && args.type === "link") {
      return (
        <Alert color="info" className="propertybar-description">
          <h1>
            <T i18nKey="descripcionDelNodo" />
          </h1>
          <p>
            <T i18nKey="nodoLinkDescripcion" />
          </p>
        </Alert>
      );
    } else if (args && args.type === "node" && args.data && args.data.type) {
      return (
        <>
          <Alert color="info" className="propertybar-description">
            <h1>
              <T i18nKey="descripcionDelNodo" />
            </h1>
            <p>
              <T i18nKey={NODE_NAMES[args.data.type].description} />
            </p>
          </Alert>
          {isNewNode() ? (
            <Alert color="danger">
              <T i18nKey="alertaNodoDesconectado" />
            </Alert>
          ) : (
            ""
          )}
        </>
      );
    }
    return null;
  };
  return (
    <div>
      <Modal
        isOpen={open}
        toggle={toggle}
        size={"lg"}
        contentClassName="generic-modal"
        returnFocusAfterClose={false}
      >
        <ModalHeader>{modalTitle()}</ModalHeader>
        <ModalBody>
          <Row>
            <Col xs="12">{modalDescription()}</Col>
            <Col xs="12">{changeComponent}</Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Col xs="9" md="5" className="mx-auto">
            <Button
              block
              color="primary"
              type="submit"
              form="formPropertyBar"
              disabled={isNewNode()}
            >
              <T i18nKey="guardar" />
            </Button>
          </Col>
          <Col xs="9" md="5" className="mx-auto">
            <Button block color="secondary" onClick={toggle}>
              <T i18nKey="cancelar" />
            </Button>
          </Col>
        </ModalFooter>
      </Modal>
    </div>
  );
}
